


































import { defineComponent, ref, toRefs } from '@vue/composition-api';
import SelectionBlocks from './index';

const name = 'ttam-selection-blocks-compose';
export default defineComponent({
  name,
  components: {
    TtamSelectionBlocksBlock: SelectionBlocks.TtamSelectionBlocksBlock,
  },
  props: {
    selections: {
      type: Array,
      required: true,
    },
    selected: {
      type: Number,
    },
    shrink: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    headerOnly: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      name,
    };
  },
});
